import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Dialog zur Abfrage: Laufende Messung fortsetzen oder neu starten (Datenverlust).
 */
function UpdateResumeDialog({ open, data, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!open || !data) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      onCancel();
    }
  };

  const handleCancelClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onCancel();
  };

  return (
    <div className="dialog-overlay" onClick={handleOverlayClick}>
      <div className="dialog-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>🔄 {t('dialog.resume.title')}</h3>
        </div>
        <div className="dialog-content">
          <p style={{ marginBottom: '20px', fontSize: '1.1rem', fontWeight: '500' }}>
            {t('dialog.resume.found_message')}
          </p>
          <div className="dialog-info">
            <p style={{ margin: '8px 0', fontSize: '0.95rem' }}>
              <strong>{t('dialog.resume.session')}</strong> {data.sessionName}
            </p>
            <p style={{ margin: '8px 0', fontSize: '0.95rem' }}>
              <strong>{t('dialog.resume.messpunkte')}</strong> {data.measurementsCount}
            </p>
            <p style={{ margin: '8px 0', fontSize: '0.95rem' }}>
              <strong>{t('dialog.resume.wa_nr')}</strong> {data.resumeNumber}
            </p>
          </div>
          <div className="dialog-actions">
            <button
              className="btn btn-primary"
              onClick={onConfirm}
            >
              {t('dialog.resume.continue')}
            </button>
            <button
              className="btn btn-secondary"
              onClick={handleCancelClick}
              style={{ backgroundColor: '#ef4444', color: 'white' }}
              title={`⚠️ ${t('dialog.resume.restart_title')}`}
            >
              ⚠️ {t('dialog.resume.restart_data_loss')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateResumeDialog;
